import { createAsyncThunk } from "@reduxjs/toolkit";
import sdkProvider from "../../../../client/sdkProvider";
import logger from "../../../../lib/logger";
import getActiveMembersDaySaleEvent from "../selectors/getActiveMembersDaySaleEvent";

const loadLoyaltyGetActiveMembersDaySaleEvent = createAsyncThunk(
  "config/loadLoyaltyGetActiveMembersDaySaleEvent",
  async (_, { rejectWithValue }) => {
    try {
      const loyaltySdk = await sdkProvider("loyalty");
      const config = await loyaltySdk.getConfig();

      return getActiveMembersDaySaleEvent(config);
    } catch (error) {
      if (error.name !== "LoyaltyNotSupportedError") {
        error.message = `loadLoyaltyGetActiveMembersDaySaleEvent failed with error: ${error.message}`;
        logger.error(error);
      }

      return rejectWithValue(error);
    }
  }
);

export default loadLoyaltyGetActiveMembersDaySaleEvent;
